export default "__VITE_ASSET__BGYz8STP__"